import i18n from "@/lib/i18n";

const DEFAULT_CURRENCY = "PLN";
const CURRENCY_SYMBOL = "zł";

/**
 * Returns CSS class based on money value
 * @param {number} value
 * @returns {string} CSS class name
 */
export function moneyClass(value) {
  if ([0, "0.00", "0"].includes(value)) return "";
  return value > 0 ? "text-success" : "text-danger";
}

/**
 * Formats currency code
 * @param {string} value - Currency code
 * @returns {string} Translated currency name
 */
export function formatCurrency(value) {
  if (typeof value !== "string" || value.length !== 3) {
    return i18n.t(DEFAULT_CURRENCY);
  }
  return i18n.t(value);
}

/**
 * Formats money value to localized string
 * @param {Object|number|string} value - Money value or object with amount property
 * @returns {string} Formatted money string
 */
export function formatMoney(value) {
  let amount = 0;

  if (value?.amount !== undefined) {
    // Handle object with amount property
    amount = parseFloat(value.amount);
  } else if (typeof value === "number" || typeof value === "string") {
    // Handle direct number or string value
    amount = parseFloat(value);
  }

  // Handle NaN and invalid values
  if (isNaN(amount)) {
    amount = 0;
  }

  return i18n.n(amount, "currency").replace(DEFAULT_CURRENCY, CURRENCY_SYMBOL);
}

export function formatUnitPrice(value) {
  let amount = 0;

  if (value?.amount !== undefined) {
    amount = parseFloat(value.amount);
  } else if (typeof value === "number" || typeof value === "string") {
    amount = parseFloat(value);
  }

  if (isNaN(amount)) {
    amount = 0;
  }

  return (
    new Intl.NumberFormat(i18n.locale?.value ?? "pl-PL", {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    }).format(amount) +
    " " +
    CURRENCY_SYMBOL
  );
}

/**
 * Creates a money object with given amount
 * @param {number} amount
 * @param {string} currency
 * @returns {Object} Money object
 */
export function createMoneyObject(amount = 0, currency = DEFAULT_CURRENCY) {
  return {
    amount: parseFloat(amount) || 0,
    currency,
  };
}
